<div class="container">
  <div class="row mb-1">
    <div class="col-md-12 d-flex justify-content-between text-end">
      <h5 class="d-inline-flex align-items-center">
        <span class="fw-bold">PACKAGE ID :</span>
        <span class="text-success fw-bold mr-5">
          {{ packageId | uppercase }}
        </span>

        &nbsp;&nbsp;&nbsp;

        <span class="text-primary" *ngIf="status==0">
          User Generated Trip
        </span>

        <span class="text-primary" *ngIf="status==1">
          Driver is on the way to pick up Package
        </span>

        <span class="text-primary" *ngIf="status==2">
          Driver is on the way to Drop Package
        </span>

        <span class="text-primary" *ngIf="status==3">
          Trip Completed
        </span>

        <span class="text-primary" *ngIf="status==4">
          User Cancelled Trip
        </span>

        <span class="text-primary" *ngIf="status==5">
          Driver Cancelled Trip
        </span>
      </h5>

      <button
        (click)="back()"
        class="btn-shadow btn btn-success d-inline-flex align-items-center"
      >
        <i class="fa fa-arrow-circle-left mr-2"></i>
        Back
      </button>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-md-12">

    <agm-map
  [latitude]="mapCenter.lat"
  [longitude]="mapCenter.lng"
  [zoom]="13"
  (mapReady)="onMapReady($event)"
  style="height:600px;width:100%">

  <!-- Driver -->
  <agm-marker
    *ngIf="driverLocation.lat"
    [latitude]="driverLocation.lat"
    [longitude]="driverLocation.lng"
    [iconUrl]="vehicleIcon">
  </agm-marker>

  <!-- Pickup -->
  <agm-marker
    [latitude]="origin.lat"
    [longitude]="origin.lng"
    [iconUrl]="greenIcon">
  </agm-marker>

  <!-- Destination -->
  <agm-marker
    [latitude]="destination.lat"
    [longitude]="destination.lng"
    [iconUrl]="redIcon">
  </agm-marker>

</agm-map>

    </div>
  </div>
</div>